import { useEffect, useState } from "react";
import {
  Box,
  Pagination,
  Stack,
  CircularProgress,
  Typography,
  IconButton,
} from "@mui/material";
import Grid from "@mui/material/Grid";
import { useFetchContext } from "../../../contexts/FetchContext";
import { IDataPagination } from "../../../interfaces";
import { PageContainer } from "../../shared/components/PageContainer";
import VerifyLocationTable from "./components/VerifyLocationTable";
import NoResult from "../../shared/components/NoResult";
import TableFilter from "../../shared/components/TableFilter";
import DownloadIcon from "@mui/icons-material/Download";
import { ProductLocationsData } from "../../../interfaces/product";
import { useSearchParams } from "react-router-dom";

export const VerifySerialNumbers = () => {
  const { state, fetchData } = useFetchContext();
  const [searchParams] = useSearchParams();

  const [order, setOrder] = useState<"ASC" | "DESC">("DESC");
  const [orderType, setOrderType] = useState<string>("quantity");
  const [searchKeyword, setSearchKeyword] = useState<string | undefined>(
    searchParams.get("searchKeyword") || undefined
  );

  const handleSortChange = (state: "ASC" | "DESC") => {
    setOrder(state);
  };

  const handleOrderTypeChange = (type: string) => {
    setOrderType(type);
  };

  const handleSearchChange = (searchTerm: string) => {
    setSearchKeyword(searchTerm);
  };

  const [data, setData] =
    useState<IDataPagination<ProductLocationsData> | null>(null);
  const [page, setPage] = useState(1);

  useEffect(() => {
    const fetchDataAsync = async () => {
      try {
        const response = await fetchData<IDataPagination<ProductLocationsData>>(
          `/products/locations?page=${page}&pageSize=10&${
            searchKeyword ? `productCode=${searchKeyword}` : ""
          }&orderType=${order}&orderBy=${orderType}`
        );

        setData(response?.data);
      } catch (error) {}
    };

    fetchDataAsync();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, searchKeyword, order, orderType]);

  return (
    <PageContainer>
      <Stack>
        <Typography variant="h6" mb={3} mt={1} align="center">
          TOTALE ARTICOLI IN GIACENZA: {data?.total ?? 0}pz
        </Typography>
        <Grid container>
          <Grid item xs={10} sx={{ pb: 2 }}>
            <TableFilter
              sortOrder={order}
              onSearchChange={handleSearchChange}
              searchKeyword={searchKeyword}
            />
          </Grid>
          <Grid
            item
            xs={2}
            sx={{ pb: 2, display: "flex", justifyContent: "center" }}
          >
            <IconButton
              color="primary"
              onClick={async () => {
                try {
                  const response = await fetchData<any>(
                    "/products/locations-check/xls",
                    "POST",
                    null,
                    undefined,
                    {
                      responseType: "blob",
                      headers: {
                        Accept:
                          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                      },
                    }
                  );

                  const blob = new Blob([response.data], {
                    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                  });
                  const url = window.URL.createObjectURL(blob);

                  const link = document.createElement("a");
                  link.href = url;
                  link.download = "locations-check.xlsx";
                  document.body.appendChild(link);
                  link.click();

                  document.body.removeChild(link);
                  window.URL.revokeObjectURL(url);
                } catch (error) {
                  console.error("Errore durante il download:", error);
                }
              }}
            >
              <DownloadIcon />
            </IconButton>
          </Grid>

          {state.isLoading ? (
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "80vh",
              }}
            >
              <CircularProgress />
            </Box>
          ) : data?.total ? (
            <VerifyLocationTable
              data={data?.items ?? []}
              order={order}
              orderType={orderType}
              handeSortChange={handleSortChange}
              handleOrderTypeChange={handleOrderTypeChange}
            />
          ) : (
            <NoResult />
          )}
        </Grid>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            pb: 15,
            mt: 5,
          }}
        >
          <Pagination
            count={data?.totalPages ?? 0}
            size="small"
            onChange={(e, page) => setPage(page)}
            page={page}
          />
        </Box>
      </Stack>
    </PageContainer>
  );
};

export default VerifySerialNumbers;
